import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Chip, TableFooter } from "@mui/material";
import { DoneAll, Clear, ExpandMoreTwoTone, ExpandLessTwoTone } from "@mui/icons-material";
import React, {useEffect, useState} from 'react'
import { motion } from "framer-motion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Laptop from '../Assets/laptop.png'
import Admission from '../Assets/admission.png'
import Data from '../Assets/data.png'
import Content from '../Assets/content.png'
import Productivity from '../Assets/productivity.png'
import CustomerService from '../Assets/customer-service.png'
import '../CSS/Module.css'

export default function School() {
    const [pricing, setPricing] = useState(false);
    const [showAll, setShowAll] = useState(false);
    
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    const handleToggleChange = () => {
        setPricing(!pricing)
    }

    const features = [
        { name: "SMS Integration*", basic: true, advanced: true, premium: true },
        { name: "WhatsApp Integration*", basic: true, advanced: true, premium: true },
        { name: "Payment Gatway Integration*", basic: true, advanced: true, premium: true },
        { name: "User Role and Permission", basic: true, advanced: true, premium: true },
        { name: "Enquiry Management", basic: true, advanced: true, premium: true },
        { name: "Admission Management", basic: true, advanced: true, premium: true },
        { name: "Transport Management", basic: true, advanced: true, premium: true },
        { name: "Fee Management", basic: true, advanced: true, premium: true },
        { name: "Fee Dues Management", basic: true, advanced: true, premium: true },
        { name: "Fee Concession Management", basic: true, advanced: true, premium: true },
        { name: "Denominator", basic: true, advanced: true, premium: true },
        { name: "Attendance Management", basic: false, advanced: true, premium: true },
        { name: "I-Card Management", basic: false, advanced: true, premium: true },
        { name: "Student Gate Pass", basic: false, advanced: true, premium: true },
        { name: "Visitor Pass", basic: false, advanced: true, premium: true },
        { name: "Appreciation Certificate", basic: false, advanced: true, premium: true },
        { name: "Bonafide/TC/Fee Certificate", basic: false, advanced: true, premium: true },
        { name: "Exam Management", basic: false, advanced: true, premium: true },
        { name: "Time Table Management", basic: false, advanced: false, premium: true },
        { name: "Library Management", basic: false, advanced: false, premium: true },
        { name: "Homework Management", basic: false, advanced: false, premium: true },
        { name: "Notice Management", basic: false, advanced: false, premium: true },
        { name: "Employee Management", basic: false, advanced: false, premium: true },
        { name: "Account Management", basic: false, advanced: false, premium: true },
        { name: "Student Web Login", basic: false, advanced: false, premium: true },
        { name: "Student App", basic: false, advanced: false, premium: true },
        { name: "Teacher App", basic: false, advanced: false, premium: true },
    ];

    const plans = [
        { name: "Basic", color: "primary" },
        { name: "Advanced", color: "secondary", popular: true },
        { name: "Premium", color: "success" },
    ];

    const displayedFeatures = showAll ? features : features.slice(0, 10);

  return (
    <>
        <section id="Solutions" className="d-flex align-items-center pt-5">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Features</h2>
                    <h3>School Management Software <span>Features</span></h3>
                </div>
                <div className="row shadow-sm mx-1">
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-end">
                        <img src={Laptop}alt="laptop" width="40" className="icon" />
                        <h4 className="title">Easy To Use</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center">
                        <img src={Admission} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Easy Document Generation</h4>
                    </div> 
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-md-start border-sm-top border-sm-end">
                        <img src={Data} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Seamless Admission Management Process </h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-md-end">
                        <img src={Content} alt="laptop" width="40" className="icon " />
                        <h4 className="title">Increase Productivity</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top">
                        <img src={Productivity} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Create Auto Backup</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-start">
                        <img src={CustomerService} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Customer Support 24*7</h4>
                    </div>
                </div>
                <nav className='my-5 mx-2'>
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <span className={`nav-link ${!pricing && 'active'}`} onClick={handleToggleChange}>Modules</span>
                      </li>
                      {/* <li className="nav-item">
                        <span className={`nav-link ${pricing && 'active'}`} onClick={handleToggleChange}>Pricing</span>
                      </li> */}
                    </ul>
                </nav>
                {!pricing &&
                    <div className="container">
                        <div className="section-title" data-aos="fade-up">
                          <h2>Modules</h2>
                          <h3>Software Module <span>Details</span></h3>
                        </div>
                        <div className="row">
                            <div className="col-md-4" data-aos="fade-right">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Student Admission</h5>
                                        <li>Student Enquiry</li>
                                        <li>View/Print Enquiry</li>
                                        <li>Student Registration</li>
                                        <li>View/Print Registration</li>
                                        <li>Student Admission</li>
                                        <li>View/Print Admission</li>
                                        <li>Student Re-admission</li>
                                        <li>Student Disable</li>
                                    </ul>
                                    <ul>
                                        <h5>Transport</h5>
                                        <li>Route Area Creation</li>
                                        <li>Route Fee Creation</li>
                                        <li>Pickup Point Creation</li>
                                        <li>Transport Allotment</li>
                                        <li>Bulk Transport Allotment</li>
                                        <li>Print/View Route Details</li>
                                        <li>Print/View Route Wise Student details </li>
                                        <li>SMS Integration</li>
                                    </ul>
                                    <ul>
                                        <h5>Fee Create</h5>
                                        <li>Registration Fees</li>
                                        <li>Academic Fees</li> 
                                    </ul>
                                    <ul>
                                        <h5>Fee Concession</h5>
                                        <li>Fee Concession Head Wise</li>
                                        <li>View Fee Concession SR No Wise</li>
                                        <li>Print Fee Concession Details</li>
                                    </ul>
                                    <ul>
                                        <h5>Fee Dues</h5>
                                        <li>Fee Dues Quarter Wise</li>
                                        <li>Fee Dues Fee Head Wise</li>
                                        <li>No Fee Dues SR No Wise</li>
                                        <li>Fee Not Deposited Yet SR No Wise</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-down">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Pass</h5>
                                        <li>Create Student Gate Pass</li>
                                        <li>View/Print Student Gate Pass</li>
                                        <li>Create Visitor Pass</li>
                                        <li>View/Print Visitor Pass</li>
                                    </ul>
                                    <ul>
                                        <h5>I-Card</h5>
                                        <li>Upload I-Card Template</li>
                                        <li>View/Print Student I-Card</li> 
                                    </ul>
                                    <ul>
                                        <h5>Certificate</h5>
                                        <li>Fee Deposit Certificate</li>
                                        <li>Bonafide Certificate</li>
                                        <li>Transfer Certificate</li>
                                        <li>Character Certificate</li>
                                        <li>Appreciation Certificate</li>
                                    </ul>
                                    <ul>
                                        <h5>Library</h5>
                                        <li>Books Entry Management</li>
                                        <li>Issue Books</li>
                                        <li>Return Books</li>
                                        <li>View Books Details</li>
                                    </ul>
                                    <ul>
                                        <h5>Home Work</h5>
                                        <li>Add/View Home Work</li> 
                                        <li>Add/View Notices</li> 
                                    </ul>
                                    <ul>
                                        <h5>Employee Management</h5>
                                        <li>Add/View Department</li> 
                                        <li>Add/View Designation</li> 
                                        <li>Add/View Employee</li> 
                                    </ul>
                                    <ul>
                                        <h5>Denominator</h5>
                                        <li>Add/View Denominator</li> 
                                        <li>Print Denominator</li>  
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-up">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Leave Management</h5>  
                                        <li>Add/View Employee Leave</li> 
                                        <li>Approve/Reject Employee Leave</li> 
                                        <li>Approve/Reject Student Leave</li> 
                                    </ul>
                                    <ul>
                                        <h5>Education Department Report</h5>
                                        <li>Class & Age Wise Boys/Girls</li>
                                        <li>Class Wise Boys/Girls</li>
                                        <li>Class & Caste Category Wise Boys/Girls</li>
                                    </ul>
                                    <ul>
                                        <h5>Student Attendance</h5>
                                        <li>Mark Student Attendance</li>
                                        <li>View Class Wise No of Student Present/Absent</li>
                                        <li>Send SMS to Absent Students</li>
                                    </ul>
                                    <ul>
                                        <h5>Examination</h5>
                                        <li>Student Subject Allotment</li>
                                        <li>Marks Entry</li>
                                        <li>Co-Scholastic Entry</li>
                                        <li>Add Remarks</li>
                                        <li>Print Admit Card</li>
                                        <li>Print Grade Card</li>
                                        <li>Auto Grade Card PDF Generate</li>
                                    </ul>
                                    <ul>
                                        <h5>MIS Reports</h5>
                                        <li>Student Profile</li>
                                        <li>Consolidated Admission Summary New & Old</li>
                                        <li>Consolidated Admission Summary Date Wise</li>
                                        <li>View/Print Day Book Reg Fee</li>
                                        <li>View/Print Day Book Fee Receipt</li>
                                        <li>View/Print Day Book TC Fee</li>
                                        <li>View/Print Head Wise Fee Receipt</li>
                                        <li>View/Print Month Wise Fee Receipt</li>
                                        <li>View/Print Total Fee Receipt</li>
                                        <li>Date & Head Wise Fees Statement</li> 
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {pricing &&
                  <Box sx={{ maxWidth: 1400, mx: "auto", textAlign: "center", p: 2 }} data-aos="fade-down">
                    <Typography variant="h3" fontWeight={600} color="primary" gutterBottom>Compare Plans</Typography>
                    <TableContainer sx={{ overflow: "scroll" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center" sx={{ transform: "scale(1.1)", background: "#D0021B", color: "white", fontWeight: "bold", fontSize: "0.8rem", padding: "4px 10px", borderTopLeftRadius: '10px', borderTopRightRadius: '10px', boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)"}}>Most Popular</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem", borderTopLeftRadius: '10px' }}>Features</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedFeatures.map((feature, index) => (
                            <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff", "& td": { py: 1 } }}>
                              <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>{feature.name}</TableCell>
                              {plans.map((plan, idx) => (
                                <TableCell key={idx} align="center" sx={{
                                  transform: plan.popular ? "scale(1.1)" : "none",
                                  zIndex: plan.popular ? 2 : 1,
                                  backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.3)" : "inherit",
                                  backdropFilter: plan.popular ? "blur(5px)" : "none",
                                  borderRadius: plan.popular ? "8px" : "0px",
                                  boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.5)" : "none"
                                }}>
                                  {feature[plan.name.toLowerCase()] ? (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <DoneAll color="success" fontSize="medium" />
                                    </motion.div>
                                  ) : (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <Clear color="error" fontSize="medium" />
                                    </motion.div>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <Chip sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", background: "#D0021B", color: "#fff", zIndex: 3 }} icon={showAll ? <ExpandLessTwoTone color="white" /> : <ExpandMoreTwoTone color="white" />} onClick={() => setShowAll(!showAll)} label={showAll ? "Show Less" : "View More"} />
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, borderTopLeftRadius: '10px' }}>NO OF STUDENTS</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>Upto 300</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">9,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">19,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#fff", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>301- 500</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">19,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">24,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>500 +</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs. 5/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">Rs 7/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs 10/Per Student/Per Month</TableCell>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </Box>
                }
            </div>
        </section>
    </>
  )
}
